export const REQUEST_TRANSLATION_TOOLBAR_LANGUAGES_URL =
  'https://api.cognitive.microsofttranslator.com/Languages'

export const REQUEST_TRANSLATION_TOOLBAR_TRANSLATE_URL =
  'https://api.cognitive.microsofttranslator.com'

export const REQUEST_TRANSLATION_TOOLBAR_SUBSCRIPTION_KEY =
  '7d814cbb81f746beb6483e0c918d780d'

export const REQUEST_TRANSLATION_TOOLBAR_FROM_QA_NAME =
  'requestTranslationToolbarFrom'

export const REQUEST_TRANSLATION_TOOLBAR_TO_QA_NAME =
  'requestTranslationToolbarTo'

export const REQUEST_TRANSLATION_TOOLBAR_SWITCH_BTN_QA_NAME =
  'requestTranslationToolbarSwitchButton'

export const REQUEST_TRANSLATION_TOOLBAR_SUBMIT_BTN_QA_NAME =
  'requestTranslationToolbarSubmitButton'

export const REQUEST_TRANSLATION_TOOLBAR_CLOSE_BTN_QA_NAME =
  'requestTranslationToolbarCloseButton'
